import { forwardRef } from 'react'
import { GenericErrors } from '@/lib/definitions/generic.types'
import { cn } from '@/lib/misc/Utils'

interface TextareaProps {
  name: string
  required?: boolean
  label?: string
  placeholder?: string
  onChange?: any
  value?: any
  errors?: GenericErrors
  autoFocus?: boolean
  className?: string
  disabled?: boolean
  rows?: number
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => {
    const { errors, name, value } = props

    let errorsFound: [string?] = []

    if (errors && errors[name]?.length > 0) {
      errorsFound = errors[name]
    }

    return (
      <div>
        <label
          htmlFor={`textarea-${props.name}`}
          className="block font-medium text-accent-60 mb-1"
        >
          {props.label}
          {props.required && <span className="text-red-500">*</span>}
        </label>

        <div>
          <textarea
            ref={ref}
            value={value}
            name={props.name}
            rows={props.rows || 3}
            id={`textarea-${props.name}`}
            data-cy={`textarea-${props.name}`}
            required={props.required ?? false}
            placeholder={props.placeholder}
            onChange={props.onChange}
            autoFocus={props.autoFocus}
            disabled={props.disabled}
            className={cn(
              'h-full w-full px-3 border bg-white rounded-lg border-solid border-neutral-20 focus:outline-1 focus:border-brand-5 focus:outline-brand-5 hover:border-neutral-40 disabled:bg-neutral-10 disabled:border-neutral-40 disabled:pointer-events-none p-2 placeholder:text-neutral-50',
              'disabled:bg-neutral-10 disabled:cursor-not-allowed hover:',
              errorsFound.length > 0 ? 'border-brand-6' : 'border-neutral-40',
              props.className || ''
            )}
          />
        </div>

        {!!errorsFound.length && (
          <div className="mt-1">
            <ul className="list-disc list-inside text-red-500 text-sm mb-2">
              {errorsFound.map((val, key: number) => (
                <li key={key}>{val}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    )
  }
)

Textarea.displayName = 'Textarea'

export default Textarea
